import * as Reflux from "reflux";
export const CustomerCartActions = {
	addItem: Reflux.createAction(["addItem"]),
	addItems: Reflux.createAction(["addItems"]),
	setItemQuantity: Reflux.createAction(["setItemQuantity"]),
	setItemComment: Reflux.createAction(["setItemComment"]),
	setItemServiceOption: Reflux.createAction(["setItemServiceOption"]),
	saveCart: Reflux.createAction(["saveCart"]),
	deleteItem: Reflux.createAction(["deleteItem"]),
	deleteItems: Reflux.createAction(["deleteItems"]),
	deleteCart: Reflux.createAction(["deleteCart"]),
	onSetManualPrice: Reflux.createAction(["onSetManualPrice"]),
	onRemoveCartFromContext: Reflux.createAction(["onRemoveCartFromContext"]),
	onRestockCart: Reflux.createAction(["onRestockCart"]),
	onLoadSavedCart: Reflux.createAction(["onLoadSavedCart"]),
	replaceArticle: Reflux.createAction(["replaceArticle"]),
};
